import { render, staticRenderFns } from "./WordImg.vue?vue&type=template&id=674b5398&scoped=true&"
import script from "./WordImg.vue?vue&type=script&lang=js&"
export * from "./WordImg.vue?vue&type=script&lang=js&"
import style0 from "./WordImg.vue?vue&type=style&index=0&id=674b5398&scoped=true&lang=css&"
import style1 from "./WordImg.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b5398",
  null
  
)

export default component.exports